import { generateCAPId } from "../../../utils/capProcessor";
import { formatDate, processDateJS } from "../../../utils/dateProcessor";

const formatDisplayDate = (date) => {
  return formatDate(processDateJS(date)) ?? "-";
};

export const buildOneSourceRefreshSummary = ({
  previousCaps,
  changedMetrics,
  refreshedCapsByKey,
  metrics,
}) => {
  const metricOrder = new Map(
    (metrics ?? [])
      .filter((metric) => metric?.metric_id)
      .map((metric, index) => [metric.metric_id, index]),
  );

  const metricMap = new Map(
    (metrics ?? [])
      .filter((metric) => metric?.metric_id)
      .map((metric) => [metric.metric_id, metric]),
  );

  const changedCaps = [];
  const changedMetricIds = new Set();

  (previousCaps ?? []).forEach((previousCap, index) => {
    const capKey = generateCAPId(previousCap);
    const refreshedCap = refreshedCapsByKey?.get(capKey);

    if (!refreshedCap) {
      return;
    }

    const rawChangedMetrics = changedMetrics?.[index] ?? {};
    const changedRows = Object.entries(rawChangedMetrics)
      .filter(([metricId]) => metricMap.has(metricId))
      .map(([metricId, value]) => ({
        metricId,
        metricName: metricMap.get(metricId)?.display_name ?? metricId,
        oldValue: value?.from,
        newValue: value?.to,
        changeValue:
          Number.isFinite(Number(value?.from)) &&
          Number.isFinite(Number(value?.to))
            ? Number(value?.to) - Number(value?.from)
            : null,
      }))
      .sort(
        (a, b) =>
          (metricOrder.get(a.metricId) ?? Number.MAX_SAFE_INTEGER) -
          (metricOrder.get(b.metricId) ?? Number.MAX_SAFE_INTEGER),
      );

    if (changedRows.length === 0) {
      return;
    }

    changedRows.forEach((row) => {
      changedMetricIds.add(row.metricId);
    });

    changedCaps.push({
      capKey,
      companyName: refreshedCap?.company_name,
      startDate: formatDisplayDate(refreshedCap?.start_date),
      endDate: formatDisplayDate(refreshedCap?.end_date),
      metrics: changedRows,
    });
  });

  return {
    changedCaps,
    orderedChangedMetricIds: (metrics ?? [])
      .filter(
        (metric) => metric?.metric_id && changedMetricIds.has(metric.metric_id),
      )
      .map((metric) => metric.metric_id),
  };
};
